import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareAuthenticatedHeaders } from './utils/headers'

export interface LoginResponse {
  key: string
}

export interface LoginRequest {
  email: string
  password: string
}

export interface WordpressLoginRequest {
  code: string
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_URL}/api/v1`,
    prepareHeaders: prepareAuthenticatedHeaders,
  }),
  tagTypes: ['Auth'],
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: credentials => ({
        url: '/login/',
        method: 'POST',
        body: credentials,
      }),
    }),
    wordpressLogin: builder.mutation<LoginResponse, WordpressLoginRequest>({
      query: credentials => ({
        url: '/wordpress-login/',
        method: 'POST',
        body: credentials,
      }),
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: '/logout/',
        method: 'POST',
      }),
    }),
  }),
})

export const { useLoginMutation } = authApi
